/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Gateway_NoteInputs */



/**
* | output |
* | --- |
* | "This is a Gateway plan — plan, storage, and copilot are fixed and managed as part of the Gateway product." |
*
* @param {Partner_Manage_Gateway_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_gateway_note = /** @type {((inputs?: Partner_Manage_Gateway_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Gateway_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies ist ein Gateway-Tarif — Tarif, Speicher und Copilot sind fest und werden als Teil des Gateway-Produkts verwaltet.")
	return /** @type {LocalizedString} */ ("This is a Gateway plan — plan, storage, and copilot are fixed and managed as part of the Gateway product.")
});